import { Injectable } from '@angular/core';
import { LocalDataSource } from '@theme/components/grid/ng2-smart-table/lib/data-source/local/local.data-source';
import { map } from 'rxjs/operators';
import { ServerSourceConf } from './server-source.conf';
import { BaseService } from '@app/@core/services/base.service';
import { HttpParams } from '@angular/common/http';
// import { getDeepFromObject } from '../helpers';


export class CustomServerDataSource extends LocalDataSource {
  protected conf: ServerSourceConf;

  lastRequestCount: number = 0;
  isLoading: boolean = false;
  constructor(private listService: BaseService, private hasConcatEq: boolean = true) {
    super();

    this.conf = new ServerSourceConf({
      dataKey: 'data',
      totalKey: 'totalCount',
    });
  }

  count(): number {
    return this.lastRequestCount;
  }
  loading(): boolean {
    return this.isLoading;
  }
  getElements(): Promise<any> {
    this.isLoading = !this.isLoading;
    const params = {};

    if (this.sortConf) {
      this.sortConf.forEach(fieldConf => {
        // url += `sorts=[_sort=${fieldConf.field},_order=${fieldConf.direction.toUpperCase()}]&`;
        params[`Sorts[${fieldConf['field']}]`] = fieldConf['direction'];
      });
    }

    if (
      this.pagingConf &&
      this.pagingConf['page'] &&
      this.pagingConf['perPage']
    ) {
      // url += `${this.conf.pagerPageKey}=${this.pagingConf['page']}&${this.conf.pagerLimitKey}=${this.pagingConf['perPage']}&`;
      params['PageIndex'] = this.pagingConf['page'];
      params['PageSize'] = this.pagingConf['perPage'];
    }
    
    if (this.filterConf.filters) {
      this.filterConf.filters.forEach(fieldConf => {
        if (fieldConf['search']) {
          // url += `${fieldConf['field']}_like=${fieldConf['search']}&`;
          if (fieldConf['filter']) {
            if (fieldConf['filter'] === 'list') {
              params[`Filters[${fieldConf['field']}]`] = (this.hasConcatEq ? 'eq' : '') + encodeURIComponent(fieldConf['search']);
            } else {
              params[`Filters[${fieldConf['field']}]`] = encodeURIComponent(fieldConf['search']);
            }
          } else {
            params[`Filters[${fieldConf['field']}]`] = encodeURIComponent(fieldConf['search']);
          }
        }
      });
    }

    if (this.searchQuery.value) {
      params['SearchQuery'] = encodeURIComponent(this.searchQuery.value);
    }
    params['ts'] = Date.now();

      return this.listService
      .getList(new HttpParams({ fromObject: params }))
      .pipe(
        map(res => {
          this.lastRequestCount = this.extractTotalFromResponse(res);
          this.data = this.extractDataFromResponse(res);
          this.isLoading = !this.isLoading;
          return this.data;
        }),
      )
      .toPromise();
  }

  /**
   * Extracts array of data from server response
   * @param res
   * @returns {any}
   */
  protected extractDataFromResponse(res: any): Array<any> {
    const data = res.data;
    // const data = !!this.conf.dataKey ? getDeepFromObject(rawData, this.conf.dataKey, []) : rawData;

    if (data instanceof Array) {
      return data;
    }

    throw new Error(`Data must be an array.
    Please check that data extracted from the server response by the key '${this.conf.dataKey}' exists and is array.`);
  }

  /**
   * Extracts total rows count from the server response
   * Looks for the count in the heders first, then in the response body
   * @param res
   * @returns {any}
   */
  protected extractTotalFromResponse(res: any): number {
    if (res[this.conf.totalKey]) {
      return res[this.conf.totalKey];
    }
  }
}
